(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Directives/Tooltip", [], factory);
	else if(typeof exports === 'object')
		exports["Directives/Tooltip"] = factory();
	else
		root["NextcloudVue"] = root["NextcloudVue"] || {}, root["NextcloudVue"]["Directives/Tooltip"] = factory();
})(window, function() {
return 